import { useContext } from 'react';

import { LiveChatContext } from 'components/LiveChat/LiveChatContext';

const useLiveChat = () => useContext(LiveChatContext);

export default useLiveChat;
